import { render } from "./riskList.vue?vue&type=template&id=55c48e26&scoped=true"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"

import "./riskList.vue?vue&type=style&index=0&id=55c48e26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55c48e26"

export default script